/**
 * ⏱ `?perf=1` 로 열었나 — 처음 열 때 한 번만 본다(쪽을 옮기면 측정이 아니다).
 *
 * 🔴 **따로 떼어 둔 파일이다.** 처음엔 측정 계산(perfReadout.ts)과 한 파일에 두었더니, 빌드가 측정 조각을 가를 때
 * 이 판정까지 그 조각에 넣었고 첫 화면이 이걸 읽으려고 **측정 조각을 늘 받았다**(2026-10-03 빌드본 걸음에서 잡음).
 */
export const PERF_ON: boolean = (() => {
  try {
    return new URLSearchParams(window.location.search).get("perf") === "1";
  } catch {
    return false; // 주소를 못 읽는 환경(검사) — 측정 안 함
  }
})();
